export default "__VITE_ASSET__CiyJX3F1__"